import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../maintenance/Maintenance.css";

import Component1 from "../service_common_components/component1/Component1";
import Component2 from "../service_common_components/component2/Component2";
import Component3 from "../service_common_components/component3/Component3";

const Inspection = () => {
  return (
    <section className="Inspection service">
      <Container>
        <h4 className="service_title">Vehicle Inspection & Valuation</h4>

      
        <Component1
          title1="Accurate Vehicle"
          title2="Assessment"
          title3="Our Vehicle Inspection & Valuation service ensures that you know the true condition and worth of your vehicle before any transaction or maintenance decision. We conduct a thorough inspection, examining every critical component, from the engine and transmission to the bodywork, tires, and interior condition. Our team of trained professionals uses precise tools and industry standards to assess the mechanical, structural, and cosmetic aspects of your vehicle. After a comprehensive evaluation, we provide an accurate valuation based on the current market trends, mileage, condition, and other relevant factors. Whether you are buying, selling, trading, or simply maintaining your vehicle, our service provides transparency, confidence, and peace of mind, helping you make informed decisions every time.Understanding the true condition and market value of your vehicle is crucial, whether you are buying, selling, or maintaining it. Our Vehicle Inspection & Valuation service provides a complete, professional assessment, giving you clarity and confidence in every decision. Our experienced team carefully examines all aspects of your vehicle, including the engine, transmission, suspension, brakes, tires, and overall body condition. We also check for hidden damages, accident history, and wear-and-tear that might affect performance or value."
          imgSrc="/assets/images/services/inspection.png"
        />

        
        <Component2
          title="Inspection Process"
          tips={[
            "Examine the vehicle’s overall condition, including make, model, and year",
            "Check for dents, scratches, paint quality, rust, and structural integrity.",
            "Assess seats, upholstery, dashboard, electronics, and other interior components.",
            "Inspect engine performance, transmission, brakes, suspension, and other critical systems.",
            "Examine tire condition, tread depth, and wheel alignment.",
            "Confirm the vehicle’s mileage and usage history."
          ]}
          list={true}
        />

        
        <Component2
          title="Benefits of Inspection & Valuation"
         tips={[
            "Reduces uncertainty about the vehicle’s health and market value.",
            "Provides documented proof of the vehicle’s condition to support pricing discussions.",
            "Assists buyers and sellers in making confident, well-informed choices.",
            "Identifies potential mechanical or structural problems before they worsen.",
            "Helps determine the true market value for buying, selling, or insurance purposes."
          ]}
          list={true}
        />

       
        <Component3
          title="Expert Tips"
          tips={[
            "Don’t ignore unusual noises, vibrations, or warning lights—early intervention prevents major repairs.",
            "Regular washing and detailing prevent corrosion and maintain aesthetics.",
            "Use car covers or park in shaded areas to prevent sun and weather damage.",
            "Avoid harsh braking or acceleration to extend the life of your engine and transmission.",
            "Maintain proper tire pressure and rotate tires periodically for even wear.",
            "Regularly check engine oil, coolant, brake fluid, and other essential fluids."
          ]}
          list={true}
        />
      </Container>
    </section>
  );
};

export default Inspection;
